<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 4.375H23C23.5304 4.375 24.0391 4.58571 24.4142 4.96079C24.7893 5.33586 25 5.84457 25 6.375V25.5C25 26.0304 24.7893 26.5391 24.4142 26.9142C24.0391 27.2893 23.5304 27.5 23 27.5H6C5.46957 27.5 4.96086 27.2893 4.58579 26.9142C4.21071 26.5391 4 26.0304 4 25.5V6.375C4 5.84457 4.21071 5.33586 4.58579 4.96079C4.96086 4.58571 5.46957 4.375 6 4.375Z"
      fill="black"
    />
    <path
      d="M5 4.375H22C22.5304 4.375 23.0391 4.58571 23.4142 4.96079C23.7893 5.33586 24 5.84457 24 6.375V25.5C24 26.0304 23.7893 26.5391 23.4142 26.9142C23.0391 27.2893 22.5304 27.5 22 27.5H5C4.46957 27.5 3.96086 27.2893 3.58579 26.9142C3.21071 26.5391 3 26.0304 3 25.5V6.375C3 5.84457 3.21071 5.33586 3.58579 4.96079C3.96086 4.58571 4.46957 4.375 5 4.375Z"
      fill="#7A7A7A"
    />
    <path
      d="M5.47297 9H21.527C22.1757 9 22.5 9.31264 22.5 9.93793V25.0621C22.5 25.6874 22.1757 26 21.527 26H5.47297C4.82432 26 4.5 25.6874 4.5 25.0621V9.93793C4.5 9.31264 4.82432 9 5.47297 9Z"
      fill="white"
    />
    <path d="M4 6H23V8.75H4V6Z" fill="#7A7A7A" />
    <path
      d="M7.5 2.5H9C9.34518 2.5 9.625 2.77982 9.625 3.125V6.25C9.625 6.59518 9.34518 6.875 9 6.875H7.5C7.15482 6.875 6.875 6.59518 6.875 6.25V3.125C6.875 2.77982 7.15482 2.5 7.5 2.5Z"
      fill="#5BADFF"
    />
    <path
      d="M18 2.5H19.5C19.8452 2.5 20.125 2.77982 20.125 3.125V6.25C20.125 6.59518 19.8452 6.875 19.5 6.875H18C17.6548 6.875 17.375 6.59518 17.375 6.25V3.125C17.375 2.77982 17.6548 2.5 18 2.5Z"
      fill="#5BADFF"
    />
    <path
      d="M6.5 13H18.5C18.6667 13 18.75 13.0833 18.75 13.25V14.25C18.75 14.4167 18.6667 14.5 18.5 14.5H6.5C6.33333 14.5 6.25 14.4167 6.25 14.25V13.25C6.25 13.0833 6.33333 13 6.5 13Z"
      fill="black"
    />
    <path
      d="M6.5 16.5H12.5C12.6667 16.5 12.75 16.5833 12.75 16.75V17.75C12.75 17.9167 12.6667 18 12.5 18H6.5C6.33333 18 6.25 17.9167 6.25 17.75V16.75C6.25 16.5833 6.33333 16.5 6.5 16.5Z"
      fill="black"
    />
    <path
      d="M6.5 20H12.5C12.6667 20 12.75 20.0833 12.75 20.25V21.25C12.75 21.4167 12.6667 21.5 12.5 21.5H6.5C6.33333 21.5 6.25 21.4167 6.25 21.25V20.25C6.25 20.0833 6.33333 20 6.5 20Z"
      fill="black"
    />
    <path
      d="M22.125 28.75C25.5768 28.75 28.375 25.9518 28.375 22.5C28.375 19.0482 25.5768 16.25 22.125 16.25C18.6732 16.25 15.875 19.0482 15.875 22.5C15.875 25.9518 18.6732 28.75 22.125 28.75Z"
      fill="#494949"
    />
    <path
      d="M22.125 28.125C19.0184 28.125 16.5 25.6066 16.5 22.5C16.5 19.3934 19.0184 16.875 22.125 16.875C25.2316 16.875 27.75 19.3934 27.75 22.5C27.75 25.6066 25.2316 28.125 22.125 28.125ZM22.125 26.25C24.1961 26.25 25.875 24.5711 25.875 22.5C25.875 20.4289 24.1961 18.75 22.125 18.75C20.0539 18.75 18.375 20.4289 18.375 22.5C18.375 24.5711 20.0539 26.25 22.125 26.25Z"
      fill="#FFC13C"
    />
    <path d="M21.625 19.5H22.625V22.5H21.625V19.5Z" fill="white" />
    <path d="M21.625 22H24.75V23H21.625V22Z" fill="white" />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'MenuBooking',
} as DefineComponent
</script>
